import(/* webpackMode: "eager" */ "/vercel/path0/app/[lang]/about/SectionChanger.tsx");
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js")